import { render, staticRenderFns } from "./SecurityAuthentication.vue?vue&type=template&id=0242b5fe&"
import script from "./SecurityAuthentication.vue?vue&type=script&lang=ts&"
export * from "./SecurityAuthentication.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports